import React from 'react'

const PlusIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_203_2178)">
                <path d="M12.0174 6.03453H7.96261V1.97891C7.96261 1.44642 7.53147 1.39977 6.99737 1.39977C6.46488 1.39977 6.03132 1.44481 6.03132 1.97891V6.03453H1.97892C1.44402 6.03453 1.39978 6.46727 1.39978 6.99976C1.39978 7.53226 1.44402 7.965 1.97892 7.965H6.03132V12.0206C6.03132 12.5531 6.46488 12.5998 6.99737 12.5998C7.53147 12.5998 7.96261 12.5531 7.96261 12.0206V7.965H12.0174C12.5515 7.965 12.5974 7.53226 12.5974 6.99976C12.5974 6.46727 12.5515 6.03453 12.0174 6.03453Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_203_2178">
                    <rect width="14" height="14" rx="2" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default PlusIcon